var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('q-page',[_c('agency-tabs',{staticClass:"q-mt-xl",attrs:{"agency-id":_vm.accountId}}),_c('account-toolbar',{attrs:{"account-id":_vm.accountId}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }